import { render, staticRenderFns } from "./SetPasswordConfirmation.vue?vue&type=template&id=81ae237a"
import script from "./SetPasswordConfirmation.vue?vue&type=script&lang=js"
export * from "./SetPasswordConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports